import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { useNewsRouter } from '../../shared/hooks/useNewsRouter';
export const NewsShowContext = createContext({
    config: {},
    data: {},
    flags: {},
    handlers: {},
    routes: {},
    updateNewsShow: () => {
        throw new Error('updateNewsShow is not implemented');
    },
});
export const useNewsShowContext = () => useContext(NewsShowContext);
export const NewsShowProvider = ({ children, config: initialConfig, data: initialData, flags: initialFlags, handlers: initialHandlers, }) => {
    const [config, setConfig] = useState(() => initialConfig);
    const [data, setData] = useState(() => initialData);
    const [handlers, setHandlers] = useState(() => initialHandlers);
    const [flags, setFlags] = useState(() => initialFlags);
    const routes = useNewsRouter();
    useEffect(() => {
        setConfig(initialConfig);
        setData(initialData);
        setFlags(initialFlags);
        setHandlers(initialHandlers);
    }, [initialConfig, initialData, initialFlags, initialHandlers]);
    const value = useMemo(() => ({
        config,
        data,
        flags,
        handlers,
        routes,
        updateNewsShow: (newsShow) => {
            if (newsShow.config) {
                setConfig((prev) => (Object.assign(Object.assign({}, prev), newsShow.config)));
            }
            if (newsShow.data) {
                setData((prev) => (Object.assign(Object.assign({}, prev), newsShow.data)));
            }
            if (newsShow.flags) {
                setFlags((prev) => (Object.assign(Object.assign({}, prev), newsShow.flags)));
            }
            if (newsShow.handlers) {
                setHandlers((prev) => (Object.assign(Object.assign({}, prev), newsShow.handlers)));
            }
        },
    }), [config, data, flags, handlers, routes]);
    return (_jsx(NewsShowContext.Provider, { value: value, children: children }));
};
//# sourceMappingURL=NewsShowContext.js.map